module.exports = __webpack_public_path__ + "img/date_grey.86634b76.svg";